import React from 'react'

import ReceivementCard from '../../../../../../components/ReceivementCard'

import { ReceivementPurchaseTable } from '../../../../components/ReceivementTables'
import { useSelector } from 'src/utils/store'

const ProductsList = React.memo(() => {
  const salesOverview = useSelector(
    (state) => state.receivement.salesOverview,
  )

  return (
    <>
      {salesOverview?.products?.map((product) => (
        <ReceivementCard
          key={`${product.idItemOrder ?? product.batches[0].idsBatch}`}
          product={product}
          BatchesTable={ReceivementPurchaseTable}
        />
      ))}
    </>
  )
})

export { ProductsList }
